module.exports = __webpack_public_path__ + "img/hasanmisbah.4aee23c3.png";